import { Box, Grid } from '@mui/material'
import _ from 'lodash'
import moment from 'moment'
import { useCallback, useEffect, useState } from 'react'

/** TRANSLATION */
import { useTranslation } from 'react-i18next'

/** CONSTANTS */
import { colors } from 'constants/theme'

/** COMPONENT */
import InputSecondNewRangePicker, { emptyRangePicker } from 'component/Input/InputSecondNewRangePicker'
import BranchFilterSearch from 'new-components/select/branch-filter-search'
import TableCustom from 'component/Table/TableCustom'
import TableRowCommon from 'component/Table/TableRowCommon'
import { CardSalesProps, handleChangeFilterSelect } from 'features/dashboard/dashboard'

/** UTILS || SLICE */
import { getSecureItem, numberFormat } from 'utils/app.utils'

/** API */
import DashboardApi, { IFInventoriesPurchase, IFSumeryFilter } from 'api/dashboard.api'
import { BranchInterface } from 'api/master/clinic.api'

/** STYLE */
import { KEY_STORAGE } from 'constants/common'
import * as UseStyled from 'features/dashboard/useStyled'

export default function HightSaleProduct(props: CardSalesProps) {
  const { t } = useTranslation()

  const [loadFirst, setLoadFirst] = useState(false);
  const dashboardMain = getSecureItem(KEY_STORAGE.DASHBOARD)
  const dashboardCurrent = dashboardMain ? JSON.parse(dashboardMain) : {}

  const [branches, setBranches] = useState<BranchInterface[]>([])
  const [branch, setBranch] = useState<(string | number)[]>(dashboardCurrent?.hightSaleProduct?.branch || ['ALL'])
  const [rangeDate, setRangeDate] = useState(dashboardCurrent?.hightSaleProduct?.rangeDate || [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')])
  const [products, setProducts]: any[] = useState([])

  const handleChangeSelectBranch = (e: any) => {
    setBranch(handleChangeFilterSelect(e))
  }

  useEffect(() => {
    if (!loadFirst) {
      const timer = setTimeout(() => {
        setLoadFirst(true);
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [props.rangeDate, props.branches]);

  useEffect(() => {
    setBranches(props.branches || [])
  }, [props.branches])

  useEffect(() => {
    loadFirst && setRangeDate(props.rangeDate || [])
  }, [props.rangeDate])

  useEffect(() => {
    loadFirst && setBranch(props.branch || [])
  }, [props.branch])

  useEffect(() => {
    props?.handleChangeDashboard && props?.handleChangeDashboard("hightSaleProduct,branch", branch)
  }, [branch])

  useEffect(() => {
    props?.handleChangeDashboard && props?.handleChangeDashboard("hightSaleProduct,rangeDate", rangeDate)
  }, [rangeDate])

  const loadData = useCallback(async () => {
    const allBranchIds = (branches || []).map((b) => b.branchId).join(',')
    const condition: IFSumeryFilter = { dateStart: rangeDate[0], dateEnd: rangeDate[1], branchId: branch[0] === 'ALL' ? allBranchIds : branch.toString() }
    const res = await DashboardApi.findTopBuyProduct(condition)
    const newProducts: any = []

    setProducts([])
    if (res.status === 200) {
      const summeris: IFInventoriesPurchase[] = res.data
      for (const x of summeris) {
        newProducts.push({
          name: x.productName,
          qty: x.qty,
          price: x.total
        },)
      }
    }

    setProducts(newProducts)
  }, [branch, rangeDate, branches])

  useEffect(() => {
    loadData()
  }, [loadData])

  const headCells = [
    { id: 'text', disablePadding: false, label: t('DASHBOARD.SALE_PRODUCT_CHART.TABLE.NAME'), class: 'p-3' },
    { id: 'text', disablePadding: false, label: t('DASHBOARD.SALE_PRODUCT_CHART.TABLE.QTY'), width: '100px', class: 'p-3' },
    { id: 'price', disablePadding: false, label: t('DASHBOARD.SALE_PRODUCT_CHART.TABLE.SUM'), width: '150px', class: 'p-3' }
  ]

  const renderData = (objData: any, no: number) => {
    const { name, qty, price } = objData

    const objRenderData = {
      key: String(no),
      id: String(no),
      obj: objData,
      columns: [
        { option: 'TEXT', align: 'left', label: name || '-', class: 'p-3' },
        { option: 'TEXT', align: 'left', label: qty || '-', class: 'p-3' },
        { option: 'TEXT', align: 'right', label: numberFormat(price || 0), class: 'p-3' },
      ]
    }

    return <TableRowCommon {...objRenderData} />
  }

  return (
    <UseStyled.Card>
      <Box className='pt-3 px-3 px-xl-4' sx={{ borderBottom: `1px solid ${colors.lightGray}`, paddingBottom: '12px' }}>
        <Grid container spacing={1} alignItems={'center'}>
          <Grid item xs={12} md={4} lg={12} xl={4} className={'w-100'}>
            <UseStyled.Title type='title' sx={{ flex: 'none' }}>{t('DASHBOARD.HIGHT_SALE_PRODUCT')}</UseStyled.Title>
          </Grid>
          <Grid item xs={12} sm={4} md={4} lg={6} xl={4} className={'w-100 pr-sm-2'}>
            <BranchFilterSearch
              branches={branches}
              value={branch}
              onchange={handleChangeSelectBranch}
            />
          </Grid>
          <Grid item xs={12} sm={4} md={4} lg={6} xl={4} className={'w-100'}>
            <InputSecondNewRangePicker
              inputHeight={40}
              value={rangeDate}
              onchange={(val) => {
                if (_.isEmpty(val)) setRangeDate(emptyRangePicker)
                else setRangeDate([moment(val[0]).format('YYYY-MM-DD'), moment(val[1]).format('YYYY-MM-DD')])
              }}
              allowClear
              onClear={() => setRangeDate(emptyRangePicker)}
            />
          </Grid>
        </Grid>
      </Box>
      <Box className='p-3 p-xl-4'>
        <TableCustom
          page={1}
          pageLimit={0}
          sortType={'ASC'}
          sortBy={''}
          rowCount={0}
          onSort={() => { return }}
          setPageLimit={() => { return }}
          setPage={() => { return }}
          headCells={headCells}
          rowsData={
            _.map(products, (product: any, index: number) => {
              return renderData(product, index)
            })
          }
          hidePagination
          tableFixedWidth
        />
      </Box>
    </UseStyled.Card>
  )
}
